<template>
  <div class="add-new-order-person rj-page-card" style="min-height: 150px">
    <div class="rj-page-card__content">
      <el-form ref="form" :model="form" class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-1 for-add-person">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                姓名:<span class="required">*</span> ：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item
                  prop="userName"
                  :rules="rules.userName"
                >
                  <el-select v-model="form.userName" filterable clearable placeholder="请选择">
                    <el-option
                      v-for="item in orderPersonList"
                      :key="item.userId"
                      :label="item.userName"
                      :value="item.userName"
                      :loading="loading"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <template>
            <div v-for="(propItem,index) in form.addPersonList" :key="index" class="for-add-person">
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    区域:<span class="required">*</span> ：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-form-item
                      :prop="'addPersonList.'+ index + '.areaName'"
                      :rules="rules.areaName"
                    >
                      <el-select
                        v-model="propItem.areaName"
                        filterable
                        remote
                        placeholder="请输入所在地区"
                        :remote-method="getAreaOptions"
                        :loading="loading"
                        @change="selectFindID(index,1)"
                      >
                        <el-option
                          v-for="item in areaOptions"
                          :key="item.areaId"
                          :label="item.areaName"
                          :value="item.areaName"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    部门:<span class="required">*</span> ：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-form-item
                      :prop="'addPersonList.'+ index + '.deptName'"
                      :rules="rules.deptName"
                    >
                      <el-select
                        v-model="propItem.deptName"
                        filterable
                        remote
                        placeholder="请输入所在部门"
                        :remote-method="getDepartOptions"
                        :loading="loading"
                        @change="selectFindID(index,2)"
                      >
                        <el-option
                          v-for="item in departOptions"
                          :key="item.deptCode"
                          :label="item.deptName"
                          :value="item.deptName"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    类型:<span class="required">*</span> ：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-form-item
                      :prop="'addPersonList.'+ index + '.privilegeType'"
                      :rules="rules.privilegeType"
                    >
                      <el-select v-model="propItem.privilegeType" clearable placeholder="请选择">
                        <el-option
                          v-for="item in typeOptionsList"
                          :key="item.dictValue"
                          :label="item.dictLabel"
                          :value="item.dictLabel"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="add-person-ass">
                <el-button type="text" @click="addParsonListFor">
                  添 加
                </el-button>
                <el-button v-if="index !== 0" type="text" @click="removeParsonListFor(index)">
                  删 除
                </el-button>
              </div>
            </div>
          </template>
        </div>
      </el-form>
      <!-- <el-form ref="form" :model="form" :rules="rules" class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                员工姓名:<span class="required">*</span> ：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="userName">
                  <el-select v-model="form.userName" clearable placeholder="请选择">
                    <el-option
                      v-for="item in orderPersonList"
                      :key="item.userId"
                      :label="item.userName"
                      :value="item.userName"
                      :loading="loading"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                所在地区:<span class="required">*</span> ：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="areaName">
                  <el-select
                    v-model="form.areaName"
                    filterable
                    remote
                    placeholder="请输入所在地区"
                    :remote-method="getAreaOptions"
                    :loading="loading"
                  >
                    <el-option
                      v-for="item in areaOptions"
                      :key="item.saleAreaID"
                      :label="item.saleAreaName"
                      :value="item.saleAreaName"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                所在部门:<span class="required">*</span> ：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="deptName">
                  <el-select
                    v-model="form.deptName"
                    filterable
                    remote
                    placeholder="请输入所在部门"
                    :remote-method="getDepartOptions"
                    :loading="loading"
                  >
                    <el-option
                      v-for="item in departOptions"
                      :key="item.deptCode"
                      :label="item.deptName"
                      :value="item.deptName"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </el-form> -->
    </div>
  </div>
</template>

<script>
import { insertInfo } from '@/API/index.js';
export default {
  name: 'AddNewOrderPerson',
  data () {
    return {
      form: {
        userName: '',
        addPersonList: [
          {
            areaName: '',
            deptName: '',
            privilegeType: ''
          }
        ]
      },
      rules: {
        userName: [
          { required: true, message: '请选择员工姓名', trigger: 'change' }
        ],
        deptName: [
          { required: true, message: '请输入所在部门', trigger: 'change' }
        ],
        areaName: [
          { required: true, message: '请输入所在地区', trigger: 'change' }
        ],
        privilegeType: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ]
      },
      addPersonList: [
        {
          areaName: '',
          deptName: '',
          privilegeType: ''
        }
      ]
    };
  },
  props: {
    orderPersonList: {
      type: Array,
      default: () => { return {}; }
    },
    departOptions: {
      type: Array,
      default: () => { return {}; }
    },
    areaOptions: {
      type: Array,
      default: () => { return {}; }
    },
    typeOptionsList: {
      type: Array,
      default: () => { return {}; }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getDepartOptions (query) {
      this.$emit('DepartOptions', query);
    },
    getAreaOptions (query) {
      this.$emit('AreaOptions', query);
    },
    selectFindID (i, val) {
      if (val === 1) {
        this.form.addPersonList[i].areaId = this.selectNameSeachId(this.areaOptions, 'areaName', this.form.addPersonList[i].areaName, 'areaId');
      }
      if (val === 2) {
        this.form.addPersonList[i].deptCode = this.selectNameSeachId(this.departOptions, 'deptName', this.form.addPersonList[i].deptName, 'deptCode');
      }
    },
    addParsonListFor () {
      let defaultItem = {
        areaName: '',
        deptName: '',
        privilegeType: ''
      };
      this.form.addPersonList.push(defaultItem);
    },
    /**
     * 从添加人员列表中移除指定项
     * 此方法用于从表单的添加人员列表中移除指定索引位置的人员信息。
     * 它通过索引值定位到特定的人员信息项，并使用splice方法从列表中将其移除。
     * 这种方式可以动态更新列表，无需重新渲染整个列表，提高了应用的性能。
     * @param {number} i - 要移除的人员信息项的索引
     */
    removeParsonListFor (i) {
      this.form.addPersonList.splice(i, 1);
    },
    // 判断区域+部门名称不可重复
    checkAreaDeptName (i) {
      let arr = [];
      this.form.addPersonList.forEach(item => {
        arr.push(item.areaName + item.deptName);
      });
      console.log(arr);
      return this.hasDuplicates(arr);
    },
    hasDuplicates (array) {
      return new Set(array).size !== array.length;
    },

    submitNewOrderPerson () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.checkAreaDeptName()) {
            this.$message.warning('区域+部门名称不可重复');
            return false;
          }
          let userId = this.selectNameSeachId(this.orderPersonList, 'userName', this.form.userName, 'userId');
          let params = JSON.parse(JSON.stringify(this.form.addPersonList));
          params.forEach(item => {
            item.userId = userId;
            item.userName = this.form.userName;
          });
          insertInfo(params).then((res) => {
            let json = res.data;
            if (json.status === '200') {
              this.$message.success('添加成功');
              this.$emit('isShow', false);
            }
          }).catch((res) => {
            this.$message.warning('添加失败');
            this.$emit('isShow', false);
          });
        } else {
          return false;
        }
      });
      /**
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let userId = '';
          let deptCode = '';
          let areaId = '';

          this.orderPersonList.forEach((item) => {
            if (item.userName === this.form.userName) {
              userId = item.userId;
            }
          });

          this.departOptions.forEach((item) => {
            if (item.deptName === this.form.deptName) {
              deptCode = item.deptCode;
            }
          });

          this.areaOptions.forEach((item) => {
            if (item.saleAreaName === this.form.areaName) {
              areaId = item.saleAreaID;
            }
          });

          let params = {
            userId: userId,
            userName: this.form.userName,
            deptCode: deptCode,
            deptName: this.form.deptName,
            areaId: areaId,
            areaName: this.form.areaName
          };
          insertInfo(params).then((res) => {
            let json = res.data;
            if (json.status === '200') {
              this.$message.success('添加成功');
              this.$emit('isShow', false);
            }
          }).catch((res) => {
            this.$message.warning('添加失败');
            this.$emit('isShow', false);
          });
        } else {
          return false;
        }
      });
      */
    },
    /**
     * 获取select列表id值
     * @param {Array} arr - 要搜索的数组
     * @param {string} arrName - 要搜索的数组的属性名
     * @param {string} name - 要搜索的值
     * @param {string} arrVal - 查询列表对应的值
     * @returns {string} val - 搜索到的值
     */
    selectNameSeachId (arr, arrName, name, arrVal) {
      let val;
      if (arr.length > 0) {
        arr.forEach((item) => {
          if (item[arrName] === name) {
            val = item[arrVal];
          }
        });
        return val;
      }
      /**
       *  arr.forEach((item) => {
            if (item.userName === this.form.userName) {
              userId = item.userId;
            }
          });
       */
    }
  }
};
</script>

<style lang="scss" scope>
  .baseInfoForm {
    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }
  .baseInfoForm{
    .el-form-item__error{
      position: relative;
    }
  }
  .required{
    color: red;
    margin-left: 3px;
  }
  .add-new-order-person{
    .rj-col-1,.rj-col-3{
      margin-bottom: 10px;
    }
    .el-select{
      width: 10rem;
    }
    .rj-col-3{
      float: left;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 30%;
    }
    .add-person-ass{
      float: left;
      display: inline-block;
      line-height: 40px;
    }
  }
</style>
<style lang="scss">
  .for-add-person{
    .el-form-item__error{
      position: absolute !important;
      top: 100%;
      left: 0;
    }
  }
</style>
